export const getEnvName = (API_URL: string): string => {
  if (API_URL.includes('staging')) {
    return 'staging'
  } else if (API_URL.includes('sandbox')) {
    return 'sandbox'
  } else if (API_URL.includes('localhost')) {
    return 'development'
  } else {
    return 'production'
  }
}
